export const REGISTRATION_ACTIONS = {
	PREV_STEP: 'PREV_STEP',
	NEXT_STEP: 'NEXT_STEP',
	SET_STEP: 'SET_STEP',
	LOGIN: 'login',
	RESET: 'RESET',
	SUCCESS: 'SUCCESS',
};
